import { SET_HAS_KNOWLEDGE } from '../actions/hasKnowledgeDataActions';

let initialState = false;

const hasKnowledgeDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_HAS_KNOWLEDGE:
            return action.payload.value
        default:
            return state;
    }
}

export default hasKnowledgeDataReducer;